/**
 * Hook per leggere i pezzi di UI "sidebar" contribuiti dai plugin
 * abilitati per un certo entityType.
 *
 * I plugin dichiarano `sidebarContributors` nel manifest (vedi
 * @crm/contracts/SidebarContributor). A differenza di
 * ActionContributor (pulsanti click-triggered), questi sono sempre
 * renderizzati nella detail-right del corrispondente entityType.
 *
 * Stesso filtering di useActionContributors/useEnabledPlugins:
 *   - plugin autorizzati dal backend (user.plugins)
 *   - plugin non disabilitati via toggle localStorage
 *   - contributor con entityType corrispondente
 */

import { useMemo } from 'react';
import type { SidebarContributor } from '@crm/contracts';
import { useEnabledPlugins } from './useEnabledPlugins';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useSidebarContributors(entityType: string): SidebarContributor<any>[] {
  const enabledPlugins = useEnabledPlugins();
  return useMemo(
    () =>
      enabledPlugins.flatMap((p) =>
        (p.sidebarContributors ?? []).filter((c) => c.entityType === entityType),
      ),
    [enabledPlugins, entityType],
  );
}
